import { render, staticRenderFns } from "./BackgroundColorBoxToolDesktop.vue?vue&type=template&id=013e3f14&scoped=true&"
import script from "./BackgroundColorBoxToolDesktop.vue?vue&type=script&lang=js&"
export * from "./BackgroundColorBoxToolDesktop.vue?vue&type=script&lang=js&"
import style0 from "./BackgroundColorBoxToolDesktop.vue?vue&type=style&index=0&id=013e3f14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013e3f14",
  null
  
)

export default component.exports